import {
   AfterViewInit,
   Component,
   ElementRef,
   HostListener,
   OnDestroy,
   OnInit,
   ViewChild,
   Input,
   OnChanges,
   SimpleChanges,
   Renderer2,
   QueryList,
   ViewChildren,
   PLATFORM_ID,
   Inject,
   AfterViewChecked,
   ChangeDetectionStrategy,
   ChangeDetectorRef,
   NgZone
} from '@angular/core';
// import { Title, Meta } from '@angular/platform-browser';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom, Subscription } from 'rxjs';
// import { SumPipe } from 'src/app/shared/pipes/sum.pipe';
import { ApiService } from 'src/app/shared/services/api.service';
import { FirestoreService } from 'src/app/shared/services/firestore.service';
import { ComplianceAccessCheckService } from 'src/app/shared/services/compliance-access-check.service';
// import { LoaderServices } from 'src/app/shared/services/loader.service';
// import { WebsoketService } from 'src/app/shared/services/websoket.service';
import { StripeFreeServices } from 'src/app/shared/services/stripe-free.service';
import { RemainingServices } from 'src/app/shared/services/remaining.service ';
import { AuthService } from 'src/app/shared/services/auth.service';
// import { HttpErrorResponse } from '@angular/common/http';
import { ViewportScroller, isPlatformBrowser } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { TypesenseService } from 'src/app/shared/services/typesense.service';
import { BreakpointObserver } from '@angular/cdk/layout';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { TRADINGVIEW_COUNTRIES } from 'src/app/utils/constants';
import { getCountryNameByCode } from 'src/app/utils/countries';
import { MarketUtilsService } from 'src/app/shared/services/market-utils.service';
import { ComplianceStatusCardComponent } from 'src/app/shared/components/compliance-status-card/compliance-status-card.component';
import { FirebaseRemoteConfigService } from 'src/app/shared/services/firebase-remote-config.service';
// import { SubscriptionService } from 'src/app/shared/services/subscription.service';
// import { SubscriptionInfoModel } from 'src/app/models/subscription-info.model';
import { ConditionalRenderingService } from 'src/app/shared/services/conditional-rendering.service';
import { PaywallPopupComponent } from 'src/app/shared/components/paywall-popup/paywall-popup.component';
import { WatchlistService } from 'src/app/shared/services/watchlist.service';
import { AnalyticsUtils } from 'src/app/shared/services/analytics-utils';
import { SEOService } from 'src/app/shared/services/seo.service';
import { PermissionsState } from 'src/app/stores/access-control/access-control.reducers';
import { Store } from '@ngrx/store';

import { TradeService } from 'src/app/shared/services/trade.service';
import { TradingEnabled } from 'src/app/models/trading.model';
import { StockOverviewDataService } from 'src/app/features/stock-screener/services/stock-overview-data-service.service';
import { Title } from '@angular/platform-browser';
import { Meta } from '@angular/platform-browser';
import { SubscriptionService } from 'src/app/shared/services/subscription.service';
import { SubscriptionInfoModel } from 'src/app/models/subscription-info.model';
import { IriDataService } from 'src/app/features/stock-screener/services/iri-data-service.service';
import { ReferrerService } from 'src/app/shared/services/referrer.service';

@Component({
    selector: 'app-stock-overview',
    templateUrl: './stock-overview.component.html',
    styleUrls: ['./stock-overview.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class StockOverviewComponent implements OnInit, AfterViewInit {
   public isShown: boolean = false;
   public showTradingViewChart = false;
   private subscriptionDataSub!: Subscription; // Note the ! operator
   userRole: string = 'free'; // Default role
   userRoleNew: string = 'free'; // Default role
   public stock: any;
   // public complianceData: any;
   public reportFormat: string = '';
   public id: string;
   public exchangeCode: string;
   public countryCode: string;
   public lastDate: Date;
   private offset: number = 0;
   public showTooltip: boolean = false;
   public tooltipPosition: string;
   public fundamentals: any;
   public fistPrice: number = 0;
   public showRequest: boolean = false;
   public showText: boolean = false;
   public dataUnavailable: boolean = false;
   public renenueRatio: number = 0;
   public interestBearingSecurities: number = 0;
   public interestBearingDebt: number = 0;
   public stockSplits: any;
   public stockDividends: any;
   public earnings: any;
   public estimates: any;
   public financial: any;
   public timezoneOffset: any;
   public scroller: string = '';
   public countryName: any;
   public fullCountryName: any;
   public currency = '';
   public chartTicker: any;
   public smallTicker: any;
   public isSubscribed: boolean = false;

   public canViewScreeningReport: boolean = false;
   public lastUpdate: any;
   public reportDate: any;
   public reportTypeSection: any;
   public reportTypeYear: any;
   showChart = true;
   candlesData: any;
   candlesTime!: number;
   priceChange!: number;
   percentChange!: number;

   @ViewChild('statusBox', { read: ElementRef }) statusBox: ElementRef;
   @ViewChild('controlBox', { read: ElementRef }) controlBox: ElementRef;
   @ViewChild('reportModal', { static: true })
   reportModal!: ComplianceStatusCardComponent;
   public results: any;
   public isMobile = false;
   public active = 1;
   public isAddedInWatchlist = false;

   stockData: any = []; // Stores stock data
   stockIndices: any = [];

   chartVisibility: number = 1;
   keyStatisticsVisibility: number = 1;
   newsVisibility: number = 1;
   pressReleaseVisibility: number = 1;
   analystRatingsVisibility: number = 1;
   investmentChecklistVisibility: number = 1;
   forecastVisibility: number = 1;
   relatedStocksVisibility: number = 1;
   priceEstimatesVisibility: number = 1;
   revenueEstimatesVisibility: number = 1;
   earningsEstimatesVisibility: number = 1;
   shariahCompliantStatus: string = '';
   activeTab: number = 0;

   iriMusaffaData: any = null;
   iriCommunityData: any = null;
   showIriReportTab: boolean = false;

   coveredCountriesTabs: string[] = [
      'Overview',
      'Shariah Compliance Report',
      // 'IRI Report',
      'Forecast',
      'News',
      'Profile',
   ];
   notCoveredAndNoReportMobileTabs: string[] = ['Overview', 'Profile'];
   notCoveredAndHasReportMobileTabs: string[] = [
      'Overview',
      'Shariah Compliance Report',
      'Profile',
   ];
   notCoveredAndNoReportDesktopTabs: string[] = ['Profile'];
   notCoveredAndHasReportDesktopTabs: string[] = [
      'Shariah Compliance Report',
      'Profile',
   ];

   notCoveredCountriesDesktopTabs: string[] = [];
   activatedTabIndex: number = 0;

   public type: string = 'Stock';
   public halalStatus: string = '';
   public monthYear: string = '';

   private subscriptions: Subscription[];

   complianceMetaLoaded: boolean = false;
   coveredCountries: any;
   paywallPopup: any;
   closeResult: any;
   detailsLoader: boolean = false;
   showComplianceReport: boolean = false;
   isAllowedCountry: boolean = false;
   pageDescription: string = '';
   @ViewChildren('section') sections!: QueryList<ElementRef>;
   showBuySellComponent: boolean = false;
   isBuySellLoading: boolean = true;
   showInvestmentChecklist: boolean = false;
   isFundamentalsSet: boolean = false;
   showIriReport: boolean = true;
   screenerReportResponse: any;
   public isBrowser: boolean;
   private dataFetchedSubscription?: Subscription;
   private popupTimeout: any;

   constructor(
      private stockService: StockOverviewDataService,
      private modalService: NgbModal,
      private apiService: ApiService,
      private authService: AuthService,
      private firestoreService: FirestoreService,
      private typesenseService: TypesenseService,
      private complianceAccessCheckService: ComplianceAccessCheckService,
      private toaster: ToastrService,
      private activeRouter: ActivatedRoute,
      // private ws: WebsoketService,
      private stripeFree: StripeFreeServices,
      private auth: AuthService,
      private remainingService: RemainingServices,
      private viewportScroller: ViewportScroller,
      private observer: BreakpointObserver,
      private marketUtilsService: MarketUtilsService,
      private router: Router,
      private configService: FirebaseRemoteConfigService,
      private conditionalRenderingService: ConditionalRenderingService,
      private watchlistService: WatchlistService,
      private renderer: Renderer2,
      private permissionStore: Store<{ permissions: PermissionsState }>,
      private analyticsUtils: AnalyticsUtils,
      private tradeApiService: TradeService,
      private route: ActivatedRoute,
      private titleService: Title,
      private metaService: Meta,
      // private seoService: SEOService,
      private seoService: SEOService,
      private iriDataService: IriDataService,
      private referrerService: ReferrerService,
      private cdr: ChangeDetectorRef,
      private ngZone: NgZone,
      @Inject(PLATFORM_ID) private platformId: Object
   ) {
      this.isBrowser = isPlatformBrowser(this.platformId);
      this.id = '';
      this.exchangeCode = '';
      this.countryCode = '';
      this.stock = {
         companyProfile: {},
         fundamentals: {},
      };
      //console.log("stock is",this.stock)
      this.statusBox = new ElementRef({ static: true });
      this.controlBox = new ElementRef({ static: true });
      this.tooltipPosition = 'top';
      this.lastDate = new Date();
      this.fundamentals = {};
      // this.complianceData = {};
      this.subscriptions = [];
      this.activeTab = parseInt(
         this.route.snapshot.queryParamMap.get('state') ?? '0'
      );
      this.activatedTabIndex = this.activeTab;
   }

   ngAfterViewInit(): void {
      // const fromExternal = this.referrerService.cameFromExternal();
      // const alreadyShown = this.referrerService.popupAlreadyShown();
      const isLoggedIn = this.authService.isLoggedIn();
      const isFirstTab = this.referrerService.isFirstTab();

      if (!isLoggedIn && isFirstTab) {
         this.popupTimeout = setTimeout(() => {
            this.auth.openAuthPopup(null, null, 'signUp', 'waitlist');
            this.referrerService.markPopupShown();
         }, 10000);
      }
   }

   getTabName(tabIndex: number) {
      const tabs = this.getTabs();
      return tabs[tabIndex] ?? '';
   }

   checkSelectedTab(tabIndex: number, name: string) {
      const tabs = this.getTabs();
      return tabs[tabIndex] === name;
   }

   getTabs() {
      if (this.isCoveredCountry()) {
         return this.getCoveredCountriesTabs();
      } else if (
         !this.isCoveredCountry() &&
         this.shariahCompliantStatus === 'NOT_UNDER_COVERAGE'
      ) {
         return this.isMobile
            ? this.notCoveredAndNoReportMobileTabs
            : this.notCoveredAndNoReportDesktopTabs;
      } else if (
         !this.isCoveredCountry() &&
         this.shariahCompliantStatus !== 'NOT_UNDER_COVERAGE'
      ) {
         return this.isMobile
            ? this.notCoveredAndHasReportMobileTabs
            : this.notCoveredAndHasReportDesktopTabs;
      }
      return [];
   }

   // getCoveredCountriesTabs() {
   //    if(!this.showIriReport) {
   //       this.coveredCountriesTabs = [
   //          'Overview',
   //          'Shariah Compliance Report',
   //          'Financials',
   //          'Forecast',
   //          'News',
   //          'Profile',
   //       ];
   //    } else {
   //       this.coveredCountriesTabs = [
   //          'Overview',
   //          'Shariah Compliance Report',
   //          'IRI Report',
   //          // 'IRI Report <span class="iri-beta-badge">Beta</span>', //for now we are not showing the beta badge
   //          'Financials',
   //          'Forecast',
   //          'News',
   //          'Profile',
   //       ];
   //    }

   //    return this.coveredCountriesTabs;
   // }

   getCoveredCountriesTabs() {
      const baseTabs = [
         'Overview',
         'Shariah Compliance Report',
         'Financials',
         'Forecast',
         'News',
         'Profile',
      ];

      if (this.showIriReportTab) {
         // Insert at 3rd position (before 'Financials')
         baseTabs.splice(2, 0, 'IRI Report');
         // baseTabs.splice(2, 0, 'ISRI Report <span class="iri-beta-badge">Beta</span>');
      }

      this.coveredCountriesTabs = baseTabs;
      return this.coveredCountriesTabs;
   }


   async ngOnInit(): Promise<void> {
      // console.log('1')
      // this.auth.openAuthPopup(null, null, 'signUp');
      // console.log('2')
      if(this.route.snapshot.params['id']) {
         this.seoService.updateCanonicalUrl(`https://musaffa.com/stock/${this.route.snapshot.params['id']}/`);
      }
      if (this.isBrowser) {
            // Handle case sensitivity for stock tickers
            if (this.route.snapshot.params['id']) {
               const symbol = this.route.snapshot.params['id'];
               // const fullSlug = this.route.snapshot.paramMap.get('id');
               // const symbol = this.getSymbolFromSlug(fullSlug);
              const tickerId = symbol.toUpperCase();
              if (tickerId !== symbol) {
               //  this.router.navigate(['/stock', `${tickerId}-${this.getExtraInfoFromSlug(fullSlug)}`], { replaceUrl: true });
                this.router.navigate(['/stock', `${tickerId}`], { replaceUrl: true });
              }
            }

            this.isMobile = window.innerWidth < 991;
         this.observer.observe('(max-width: 991px)').subscribe((result) => {
            this.isMobile = result.matches;
         });
         this.tradeApiService.tabChangeDetail$.subscribe((value) => {
            if (value === 'details-tab')
               this.onGoToComplianceTab(

                  this.stock?.companyProfile?.ticker,
                  this.stock?.companyProfile?.shariahCompliantStatus
               );

         });
      }


      // console.log("small",this.smallTicker)
      // console.log("Ranking Data",this.stock)
      // this.subscriptions.push(
      //    SubscriptionService.subscriptionData.subscribe(
      //       (data: SubscriptionInfoModel) => {

      //          this.userRole = data.role;
      //       }
      //    )

      // );
      // Fetch IRI data
      // await this.fetchIriData();

      this.tradeApiService.tabChangeDetail$.subscribe((value) => {
         if (value === 'details-tab')
            this.onGoToComplianceTab(
               this.stock?.companyProfile?.ticker,
               this.stock?.companyProfile?.shariahCompliantStatus
            );
      });

      this.subscriptions.push(
         this.permissionStore
            .select(({ permissions }) => permissions.permissions)
            .subscribe((permission) => {
               this.showComplianceReport = permission.stock_compliance_report;
               this.showInvestmentChecklist = permission.investment_checklist;
            })
      );
      this.allowedCountry();
      this.featureVisibilityFlag();

      // Wait for subscription data to be fetched once before subscribing to route changes
      const log = (window as any).ssrLog || console.error;
      log('StockOverviewComponent: subscribing to subscriptionData');
      this.dataFetchedSubscription =
         SubscriptionService.subscriptionData.subscribe(
            (subscriptionData: any) => {
               if (subscriptionData.isDataFetched) {
                  this.dataFetchedSubscription?.unsubscribe();
                  this.userRoleNew = subscriptionData.newRole || 'free';
                  this.isSubscribed = subscriptionData.isSubscribed;
                  this.cdr.markForCheck();

                  this.activeRouter.params.subscribe(() => {
                     const symbol = this.route.snapshot.paramMap.get('id');
                     this.activatedTabIndex = 0;

                     if (symbol && symbol !== this.id) {
                        this.id = symbol;
                        this.screenerReportResponse = undefined;
                        
                        // Run heavy data fetching outside the zone to avoid massive change detection overhead
                        this.ngZone.runOutsideAngular(() => {
                           this.stockGetInfo();
                           this.chkIsAddedInWatchlist();
                        });
                     }
                  });
               }
            }
         );

      // this.titleService.setTitle('Musaffa | Stock detail');

      this.remainingService.update();

      this.subscriptions.push(
         this.route.fragment.subscribe((fragment) => {
            if (fragment && this.isBrowser) {
               this.handleFragmentScroll(fragment);
            }
         })
      );

      // if(!this.auth.isLoggedIn()) {
      //    setTimeout(() => {
      //       this.auth.openAuthPopup()
      //    }, 3000);
      // }
   }

   private handleFragmentScroll(fragment: string) {
      if (!this.isBrowser) return;
      
      // Wait for data to be loaded and view to be rendered
      const checkAndScroll = () => {
         const element = document.getElementById(fragment);
         if (element) {
            element.scrollIntoView({ behavior: 'smooth', block: 'start' });
            return true;
         }
         return false;
      };

      // Try multiple times as content might be async
      let attempts = 0;
      const interval = setInterval(() => {
         if (checkAndScroll() || attempts > 20) {
            clearInterval(interval);
         }
         attempts++;
      }, 500);
   }

   getSymbolFromSlug(slug: string | null): string {
      if (!slug) return '';
      const parts = slug.split('-');
      return parts[0];
   }

   getExtraInfoFromSlug(slug: string | null): string {
      if (!slug) return '';
      const parts = slug.split('-');
      return parts.slice(1).join('-');
   }

   async fetchIriData(): Promise<void> {
      // console.log("this.stock?.companyProfile?.ticker", this.stock)
      try {
         if (!this.stock?.companyProfile?.ticker) return;

         // Fetch both IRI data sources in parallel
         const [musaffaData, communityData] = await Promise.all([
            this.iriDataService.getMusaffaIriData(
               this.stock.companyProfile.ticker
            ),
            this.iriDataService.getCommunityIriData(
               this.stock.companyProfile.ticker
            ),
         ]);

         this.iriMusaffaData = musaffaData;
         this.iriCommunityData = communityData;


         // Determine if we should show the IRI Report tab
         this.showIriReportTab = !!(musaffaData || communityData);
      } catch (error) {
         console.error('Error fetching IRI data:', error);
         this.showIriReportTab = false;
      }
   }

   async fetchStockData(symbol: string): Promise<void> {
      try {
         if(!this.isBrowser) return;
         const data = await this.stockService.getStockData(symbol);

         // Extract stock data
         this.stockData = [
            { label: 'pc_ytd', value: data.priceChangeYTDPercent },
            { label: 'pc_1y', value: data.priceChange1YPercent },
            { label: 'pc_3y', value: data.priceChange3YPercent },
            { label: 'pc_5y', value: data.priceChange5YPercent },
            { label: 'c_c', value: data.company_country },
         ];

         // Fetch stock indices and extract relevant fields
         if (data.company_country && this.isBrowser) {
            const indices = await this.stockService.getStockIndices(
               data.company_country
            );

            this.stockIndices = indices.hits.map((hit: any) => {
               const index = hit.document;
               return [
                  { label: 'pc_ytd', value: index.priceChangeYTDPercent },
                  { label: 'pc_1y', value: index.priceChange1YPercent },
                  { label: 'pc_3y', value: index.priceChange3YPercent },
                  { label: 'pc_5y', value: index.priceChange5YPercent },
                  { label: 'index_name', value: index.name },
               ];
            });
         }
      } catch (error) {
         console.error('Failed to fetch stock data:', error);
      }
   }

   ngOnDestroy(): void {
      if (this.subscriptions && this.subscriptions.length > 0) {
         this.subscriptions.forEach((item) => {
            item.unsubscribe();
         });
      }

      if (this.popupTimeout) {
         clearTimeout(this.popupTimeout);
      }
   }

   screenerDataLoaded(event: any) {
      this.screenerReportResponse = event;
   }

   onViewSampleClicked(componentName: string) {
      this.conditionalRenderingService.setComponentType(componentName);
   }

   async allowedCountry() {
      // if (!isPlatformBrowser(this.platformId)) return;
      const data: any = await this.marketUtilsService.fetchCountries();
      this.coveredCountries = data
         .filter(
            (obj: any) =>
               obj.stockEnabled &&
               obj.stocksCovered &&
               obj.detailedProfileAvailable
         )
         .map((obj: any) => obj.countryCode);
   }

   isCoveredCountry() {
      return this.coveredCountries?.includes(this.countryName);
   }

   handleComplianceReport() {
      if (this.userRole === 'ANONYMOUS') {
         this.router.navigate(['/authentication/login']);
      } else if (this.userRole === 'FREEMIUM') {
         this.paywallPopup = this.modalService.open(PaywallPopupComponent, {
            centered: true,
            modalDialogClass: 'paywall-popup-modal',
            size: 'xl',
         });
      } else {
         this.openModalReport(this.reportModal);
      }
   }

   openModalReport(content: any) {
      if (this.isBrowser) {
         this.modalService.open(content, {
            size: 'xl',
            scrollable: true,
         });
      }
   }

   tabChange(tabIndex: any) {
      this.activatedTabIndex = tabIndex;
      if (this.isBrowser) {
         window.scrollTo({ top: 0 });
      }
      this.cdr.markForCheck();
   }

   scrollToSection(sectionIndex: number): void {
      if (this.isBrowser) {
         const section = this.sections.toArray()[sectionIndex];
         if (section) {
            section.nativeElement.scrollIntoView({
               behavior: 'smooth',
               block: 'start',
            });
         }
      }
   }

   onGoToComplianceTab(symbol: string, compliance: string) {
      if (
         !this.isMobile &&
         !this.isCoveredCountry() &&
         this.stock?.companyProfile?.shariahCompliantStatus !==
         'NOT_UNDER_COVERAGE'
      ) {
         this.activatedTabIndex = 0;
      } else {
         this.activatedTabIndex = 1;
      }

      this.analyticsUtils.StockDetails_ScreeningReport_Tapped(
         symbol,
         compliance
      );
   }

   cannotViewCompliance() {
      this.shariahCompliantStatus = 'LOCKED';
      this.complianceMetaLoaded = true;
   }

   async featureVisibilityFlag() {
      if (!isPlatformBrowser(this.platformId)) return;
      let config = await this.configService.getFeatureVisibilityDefaults();
      this.chartVisibility = config['stock_chart'];
      this.keyStatisticsVisibility = config['key_statistics'];
      this.newsVisibility = config['news'];
      this.pressReleaseVisibility = config['press_release'];
      this.analystRatingsVisibility = config['analyst_rating'];
      this.investmentChecklistVisibility = config['investment_checklist'];
      this.forecastVisibility = config['forecast_overview'];
      this.relatedStocksVisibility = config['related_stocks'];
      this.priceEstimatesVisibility = config['price_estimates'];
      this.revenueEstimatesVisibility = config['revenue_estimates'];
      this.earningsEstimatesVisibility = config['earnings_estimates'];
   }

   async getComplianceInfo(companyProfile: any) {
      // if (!isPlatformBrowser(this.platformId)) return;
      // console.log("getComplianceInfo", companyProfile)
      let data = null;
      try {
         const response: any = await this.apiService.getStockComplianceMeta(
            companyProfile.mainTicker
         );
         data = response.data;
      } catch (e) { }
      if (data && data?.lastUpdate) {
         this.canViewScreeningReport = data.canViewScreeningReport;
         this.lastUpdate = data.lastUpdate;
         this.reportTypeSection = data.reportTypeSection;
         this.reportTypeYear = data.reportTypeYear;
         this.reportFormat = data.reportFormat;
         this.reportDate = data.reportDate;
      } else {
         this.shariahCompliantStatus = 'NOT_UNDER_COVERAGE';
         this.reportFormat = 'NEW';
      }
      this.complianceMetaLoaded = true;
   }

   async checkAllowedCountry() {
      // if (!isPlatformBrowser(this.platformId)) return;
      const countries = (await this.marketUtilsService.fetchCountries())
         ?.filter((country: any) => !!country.detailedProfileAvailable)
         .map((country: any) => country.countryCode);
      this.isAllowedCountry = !!countries?.includes(this.countryName);
   }

   getChartTicker() {
      if (this.countryName === 'US') return this.id.replace('-', '_');
      else {
         return this.id.split('.')?.[0].replace('-', '_');
      }
   }
   getChartTicker2() {
      if (this.countryName === 'US') return this.id.replace('-', '_');
      else {
         return this.id;
      }
   }

   stockGetInfo() {
      return new Promise<void>(async (resolve) => {
         this.detailsLoader = true;
         this.cdr.detectChanges(); // Show loader immediately

         let data: any = null;
         try {
            const res = await this.typesenseService.getCompanyProfileAndDataFromSymbols([this.id]);
            data = res[this.id];
            
            if (data) {
               this.stock.companyProfile = data;
               await this.getComplianceInfo(data);
               
               const canViewResponse = await this.complianceAccessCheckService.canViewStockCompliance(this.id, data.mainTicker);
               this.canViewScreeningReport = canViewResponse;
               this.shariahCompliantStatus = data.shariahCompliantStatus;
               this.updateMetaTags();
            }

            this.countryName = data?.country;
            this.exchangeCode = data?.exchange;
            this.fullCountryName = getCountryNameByCode(this.countryName);
            this.checkAllowedCountry();

            if (this.exchangeCode) {
               const dataRes = await this.tradeApiService.isTradingEnabled(this.exchangeCode);
               this.showBuySellComponent = (dataRes as TradingEnabled).data.is_trading_enabled;
            }
            this.isBuySellLoading = false;
         } catch (e) {
            console.error('error in stockGetInfo', e);
         }

         if (data) {
            this.dataUnavailable = false;
            this.analyticsUtils.etfViewed(data.ticker, data.mainTicker);
            
            const enabledCountriesCode: any = await this.marketUtilsService.fetchEnabledStockCountriesCode();
            if (!enabledCountriesCode.includes(data.country)) {
               this.dataUnavailable = true;
               this.detailsLoader = false;
               this.cdr.detectChanges();
               return;
            }
            
            this.stock.companyProfile = data;
            await this.fetchIriData();
            this.currency = data.currency;
            this.getPriceData(this.id);
            this.chartTicker = this.getChartTicker();
            this.fetchStockData(this.id);

            if (this.countryName === 'US') {
               this.showTradingViewChart = true;
            } else if (this.countryName === 'IN') {
               if (data.exchange === 'NSE') {
                  const res = await this.typesenseService.getBseTickers(this.chartTicker, '');
                  if (res.hits.length > 0) {
                     this.showTradingViewChart = true;
                     this.chartTicker = `BSE:${this.chartTicker}`;
                  } else this.showTradingViewChart = false;
               } else if (data.exchange === 'BOM') {
                  const res = await this.typesenseService.getBseTickers('', this.chartTicker);
                  let ticker = res.hits[0]?.document.ticker ?? '';
                  if (ticker) {
                     ticker = ticker.replaceAll('-', '_');
                     this.showTradingViewChart = true;
                  }
                  this.chartTicker = `BSE:${encodeURIComponent(ticker)}`;
               }
            } else if (['AU', 'CA', 'EG', 'ID', 'ES', 'TR', 'AE'].includes(this.countryName)) {
               this.chartTicker = `${data.exchange}:${this.chartTicker}`;
               this.showTradingViewChart = true;
            } else {
               this.showTradingViewChart = false;
            }
         } else {
            this.dataUnavailable = true;
         }
         
         this.detailsLoader = false;
         this.cdr.detectChanges(); // Final update to reflect all data
         resolve();
      });
   }

   openWatchListUi() {
      this.isShown = true;
   }

   getPriceData(symbols: string) {
      this.typesenseService.getPrices([symbols]).then((res) => {
         if ([symbols].length > 0) {
            for (const key in res) {
               let priceValue = res[key];
               if (this.stock) {
                  if (this.id == priceValue.id) {
                     this.fundamentals = priceValue;
                     this.priceChange = Math.abs(this.fundamentals?.change);
                     this.percentChange = Math.abs(this.fundamentals?.percentChange);

                     const dateTimeParts = this.fundamentals?.datetime?.split('T');
                     if (dateTimeParts?.length === 2) {
                        this.timezoneOffset = dateTimeParts[1].slice(8);
                        this.lastDate = new Date(`${dateTimeParts[0]} ${dateTimeParts[1].slice(0, 8)}`);
                        if (this.timezoneOffset.length < 2) this.timezoneOffset = '';
                     } else {
                        this.lastDate = new Date(this.fundamentals.datetime);
                     }
                     if (this.isBrowser) {
                        setTimeout(() => {
                           this.detailsLoader = false;
                           this.cdr.detectChanges();
                        }, 1000);
                     } else {
                        this.detailsLoader = false;
                        this.cdr.detectChanges();
                     }
                  }
               }
            }
         }
      });
   }

   public request() {
      let stockName = this.stock.companyProfile.ticker;
      let companyName = this.stock.companyProfile.name;

      // this.loader.show();
      this.detailsLoader = true;
      let subscription = this.apiService
         .requestAnalitcs(stockName, companyName)
         .subscribe((data: any) => {
            this.showRequest = true;
            this.detailsLoader = false;
         });
   }

   public chartEvent(element: any) {
      this.showChart = element;
   }

   public getStartPrice(element: any) {
      this.fistPrice = element.open;
   }

   public showPaymentStatus() {
      this.stripeFree.show(402);
   }

   checkRole(role: string): boolean {
      return this.auth.checkRole(role);
   }

   public onClick(elementId: string): void {
      if (this.isBrowser) {
         this.viewportScroller.scrollToAnchor(elementId);
         this.scroller = elementId;
      }
   }

   async chkIsAddedInWatchlist() {
      if (this.authService.getUserId()?.length) {
         const watchlists: any = await lastValueFrom(
            this.watchlistService.fetchAllWatchlist()
         );
         this.isAddedInWatchlist =
            watchlists?.data
               ?.map((item: any) => item.watchlist_symbols)
               ?.flat()
               ?.map((item: any) => item.symbol)
               ?.includes(this.id) ?? false;
      } else {
         this.isAddedInWatchlist = false;
      }
      this.cdr.markForCheck();
   }

   closeWatchListUi() {
      this.isShown = false;
      this.chkIsAddedInWatchlist();
   }

   getQuarterText() {
      var quarter = '';
      if (['Annual', 'ANNUAL'].includes(this.reportTypeSection || '')) {
         var text = `${this.reportTypeYear} Annual`;
         return text;
      } else {
         switch (this.reportTypeSection) {
            case 'firstQuarter':
            case 'FIRST_QUARTER':
               quarter = 'Q1';
               break;
            case 'secondQuarter':
            case 'SECOND_QUARTER':
               quarter = 'Q2';
               break;
            case 'thirdQuarter':
            case 'THIRD_QUARTER':
               quarter = 'Q3';
               break;
            case 'fourthQuarter':
            case 'FOURTH_QUARTER':
               quarter = 'Q4';
               break;
            default:
               quarter = '';
         }

         // var text = `${this.reportTypeYear} ${quarter} Quarter Report`;
         var text = `${quarter} ${this.reportTypeYear}`;
         return text;
      }
   }

   getDescriptionComplianceText() {
      const stockName = this.stock.companyProfile.name;
      const ticker = this.stock.companyProfile.ticker;
      const date = this.lastUpdate ? new Date(this.lastUpdate * 1000) : new Date();
      const monthYear = date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

      return `Is ${stockName} halal? Check the Shariah compliance status of ${stockName} (${ticker}) as of ${monthYear}, based on Musaffa’s Islamic stock screening methodology.`;
   }

   private updateMetaTags(): void {
      if (this.stock.companyProfile) {
         this.titleService.setTitle(
            `Is ${this.stock.companyProfile.name} - ${this.stock.companyProfile.id} Stock Halal and Shariah Compliant?`
         );
         const description = this.getDescriptionComplianceText();
         this.metaService.updateTag({
            name: 'description',
            content: description,
         });
         this.seoService.updateRobots('index, follow');

         const stockName = this.stock.companyProfile.name;
         const ticker = this.stock.companyProfile.ticker;
         const date = this.lastUpdate ? new Date(this.lastUpdate * 1000) : new Date();
         this.monthYear = date.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });
         
         this.halalStatus = 'NOT COVERED';
         switch (this.stock.companyProfile.sharia_compliance) {
            case 'COMPLIANT': this.halalStatus = 'HALAL'; break;
            case 'NON_COMPLIANT': this.halalStatus = 'NOT HALAL'; break;
            case 'QUESTIONABLE': this.halalStatus = 'DOUBTFUL'; break;
         }

         const jsonLd = {
            "@context": "https://schema.org",
            "@graph": [
               {
                  "@type": "WebPage",
                  "name": stockName,
                  "description": description,
                  "url": `https://musaffa.com/stock/${this.id}/`,
                  "publisher": {
                     "@type": "Organization",
                     "name": "Musaffa",
                     "url": "https://musaffa.com"
                  }
               },
               {
                  "@type": "FAQPage",
                  "@id": `https://musaffa.com/stock/${this.id}#faq`,
                  "mainEntity": [
                     {
                        "@type": "Question",
                        "name": `Is ${stockName} halal to invest in?`,
                        "acceptedAnswer": {
                           "@type": "Answer",
                           "text": `According to Musaffa's Shariah screening methodology, ${stockName} (${ticker}) is currently classified as ${this.halalStatus} as of ${this.monthYear}. The classification is based on an evaluation of the company's business activities and financial ratios to determine whether it meets Islamic investment guidelines.`
                        }
                     },
                     {
                        "@type": "Question",
                        "name": `Is ${stockName} a Shariah-compliant stock?`,
                        "acceptedAnswer": {
                           "@type": "Answer",
                           "text": `A stock is Shariah-compliant if the company operates in permissible business activities and meets Islamic financial screening thresholds. Musaffa analyzes ${stockName} using these criteria to determine its compliance status.`
                        }
                     },
                     {
                        "@type": "Question",
                        "name": `Can Muslims buy shares of ${stockName}?`,
                        "acceptedAnswer": {
                           "@type": "Answer",
                           "text": `Muslim investors may consider investing in ${stockName} if it meets Shariah compliance standards. Investors typically review the company's business activities, debt levels, and non-permissible income before making a decision.`
                        }
                     },
                     {
                        "@type": "Question",
                        "name": `Why is ${stockName} classified as ${this.halalStatus}?`,
                        "acceptedAnswer": {
                           "@type": "Answer",
                           "text": `Musaffa determines the Shariah status of ${stockName} by analyzing whether the company's core business operations are permissible and whether its financial ratios fall within accepted Islamic thresholds.`
                        }
                     },
                     {
                        "@type": "Question",
                        "name": `How often is the Shariah compliance for ${stockName} updated?`,
                        "acceptedAnswer": {
                           "@type": "Answer",
                           "text": `The Shariah compliance status of ${stockName} may be updated periodically when new financial statements, earnings reports, or business activity information become available.`
                        }
                     },
                     {
                        "@type": "Question",
                        "name": `Can a halal stock like ${stockName} become non-compliant?`,
                        "acceptedAnswer": {
                           "@type": "Answer",
                           "text": `Yes. A stock that is currently Shariah-compliant may become non-compliant if the company's financial ratios exceed Shariah thresholds or its business activities change.`
                        }
                     },
                     {
                        "@type": "Question",
                        "name": `Where can I check the Shariah status of ${stockName}?`,
                        "acceptedAnswer": {
                           "@type": "Answer",
                           "text": `You can check the latest Shariah compliance status of ${stockName} on Musaffa's stock page, where screening results and key financial indicators are updated to help Muslim investors make informed decisions.`
                        }
                     }
                  ]
               }
            ]
         };
         this.seoService.updateJsonLd(jsonLd);
      }
   }
}
